import React, { useRef, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import useHandleUserMessage from '../../hooks/useHandleUserMessage';
import {
  NextQuestionContainer,
  NextQuestionContentContainer,
  NextQuestionContentAll,
  NextQuestionItem,
  CONTAINER_WIDTH
} from '../styled';

const STEP = 100;
const ANIMATION_STEP = 4;

export default function NextQuestion ({ text, getStream, isLoading }) {

  const containerRef = useRef<HTMLDivElement>(null);
  const allContentRef = useRef<HTMLDivElement>(null);

  const [leftArrowAvailable, setLeftArrowAvailable] = useState(false);
  const [rightArrowAvailable, setRightArrowAvailable] = useState(true);

  const [askedList, setAskedList] = useState<string[]>([]);

  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleSendQuestion = (question) => {
    if (isLoading || askedList.includes(question)) {
      return;
    }
    submitQuestion(question);
    setAskedList([...askedList, question]);
  };

  const scrollToTarget = (target, direction) => {
    if (!containerRef.current || !allContentRef.current) {
      return;
    }
    if (direction === 'left') {
      if (containerRef.current.scrollLeft > target && containerRef.current.scrollLeft > 0) {
        containerRef.current.scrollLeft -= ANIMATION_STEP;
        requestAnimationFrame(scrollToTarget.bind(null, target, direction));
      }
    } else if (direction === 'right') {
      if (containerRef.current.scrollLeft < target
          && containerRef.current.scrollLeft < (allContentRef.current.clientWidth - CONTAINER_WIDTH)) {
        containerRef.current.scrollLeft += ANIMATION_STEP;
        requestAnimationFrame(scrollToTarget.bind(null, target, direction));
      }
    }
  }

  const scrollLeft = () => {
    if (!containerRef.current || !allContentRef.current) {
      return;
    }
    const targetOffset = Math.max(containerRef.current.scrollLeft - STEP, 0);
    scrollToTarget(targetOffset, 'left');
  };

  const scrollRight = () => {
    if (!containerRef.current || !allContentRef.current) {
      return;
    }
    const targetOffset = Math.min(containerRef.current.scrollLeft + STEP, allContentRef.current.clientWidth);
    scrollToTarget(targetOffset, 'right');
  };

  const handleScroll = (e) => {
    if (!containerRef.current || !allContentRef.current) {
      return;
    }
    const scrollLeft = e.target.scrollLeft;
    setLeftArrowAvailable(scrollLeft !== 0);
    setRightArrowAvailable(containerRef.current.clientWidth + scrollLeft < allContentRef.current.clientWidth);
  };

  return <NextQuestionContainer>
    <LeftOutlined
      style={{
        marginRight: '10px',
        color: leftArrowAvailable ? '#828282' : '#cccccc',
        cursor: leftArrowAvailable ? 'pointer' : 'not-allowed'
      }}
      onClick={scrollLeft}
    />
    <NextQuestionContentContainer ref={containerRef} onScroll={handleScroll}>
      <NextQuestionContentAll ref={allContentRef}>
        {text.map((question, index) => {
          const wordsList = question.split(' ');
          const middleIndex = Math.ceil(wordsList.length / 2);
          const firstPart = wordsList.slice(0, middleIndex).join(' ');
          const secondPart = wordsList.slice(middleIndex).join(' ');
          const hasAsked = askedList.includes(question);
          return <NextQuestionItem
            className={hasAsked ? 'asked' : ''}
            key={index}
            onClick={() => {
              handleSendQuestion(question);
            }}
          >
            {firstPart} <br /> {secondPart}
          </NextQuestionItem>
        })}
      </NextQuestionContentAll>
    </NextQuestionContentContainer>
    <RightOutlined
      style={{
        marginLeft: '10px',
        color: rightArrowAvailable ? '#828282' : '#cccccc',
        cursor: rightArrowAvailable ? 'pointer' : 'not-allowed'
      }}
      onClick={scrollRight}
    />
  </NextQuestionContainer>
}
